var _rect, _rect2, _rect3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 510 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 510,
    height: 300,
    fill: "#003893"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 510,
    height: 75,
    y: 150,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 510,
    height: 25,
    y: 175,
    fill: "#cf2027"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f7d116",
    transform: "translate(191.25,187.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "s",
    transform: "translate(0,-75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M0,-15V0H7.5",
    transform: "rotate(18,0,-15)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    transform: "scale(-1,1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(288)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    y: 150
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s2",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s2",
    transform: "rotate(144)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s2",
    transform: "rotate(216)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s2",
    transform: "rotate(288)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCv);
export default __webpack_public_path__ + "static/media/cv.46937889269d9fe52f2d7906255c65f9.svg";
export { ForwardRef as ReactComponent };